import { isMendsVisionEnabled } from '../mendsAi/services/MendsVisionService';

/** Tela inicial depois do login: Hoje com o MENDS AI ligado; o Dashboard legado só sem ele. */
export function homePath(visionEnabled: boolean = isMendsVisionEnabled()): string {
  return visionEnabled ? '/hoje' : '/dashboard';
}
